import { debounce } from '@/utils/index'
enum EnumSize {
  Normal = `normal`,
  Pad = `pad`,
  Mobile = `mobile`,
}
export interface SizeChangeCBArgs {
  isKeepSize: boolean
  size: EnumSize
}

// 基准大小
const BASE_SIZE = 100
// 设计稿宽度
const DESIGN_WIDTH = 375

const reponsive = {
  size: EnumSize.Normal,
  fontSize: 100,
  callback: ({ isKeepSize, size }: SizeChangeCBArgs) => {},
  executeSize() {
    const isRealMobile = /Mobile|Android/.test(navigator.userAgent)
    const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
    const hiddenScroll = document.body.style.overflow === 'hidden'

    const scrollbarWidth = isRealMobile || hiddenScroll ? 0 : isMac ? 15 : 17
    const bodyWidth = document.documentElement.clientWidth + scrollbarWidth
    if (bodyWidth > 1300) {
      this.size = EnumSize.Normal
      this.fontSize = 100
    } else if (bodyWidth > 1080) {
      this.size = EnumSize.Normal
      this.fontSize = 96
    } else if (bodyWidth > 640) {
      this.size = EnumSize.Pad
      this.fontSize = 84
    } else {
      this.size = EnumSize.Mobile
      // 计算缩放比例
      const scale = bodyWidth / DESIGN_WIDTH
      // 限制缩放比例在合理范围内，避免过大或过小
      const minScale = 0.5 // 最小缩放比例
      const maxScale = 1.2 // 最大缩放比例
      const adjustedScale = Math.max(minScale, Math.min(scale, maxScale))
      // 移动设备使用不同的计算方式
      this.fontSize = BASE_SIZE * adjustedScale
      // this.fontSize = 80
    }
    const html = document.documentElement
    html.style.fontSize = this.fontSize + 'px'
    html.style.setProperty('--font-size-global', `${this.fontSize}`)
    const current = html?.dataset?.reponsive
    if (current !== this.size) {
      html.dataset.reponsive = this.size
    }
    const isKeepSize = current === this.size
    if (this.callback) {
      this.callback({
        isKeepSize,
        size: this.size,
      })
    }
  },
  init(cb: (arg0: SizeChangeCBArgs) => void | null) {
    if (cb) {
      this.callback = cb
    }
    this.executeSize()
    window.addEventListener(`resize`, debounce(this.executeSize.bind(this), 200))
  },
}
export default reponsive
